module.exports = __webpack_public_path__ + "img/faq4.d4e6d27f.png";